module.exports = __webpack_public_path__ + "img/Airbnb-Work-From-Home-Home-Stretches.b734aba3.jpg";